const guiColors = {
    'motion-primary': 'hsla(260, 60%, 60%, 1)',
    'motion-primary-transparent': 'hsla(260, 60%, 60%, 0.9)',
    'motion-tertiary': 'hsla(260, 42%, 51%, 1)',

    'looks-secondary': 'hsla(260, 60%, 60%, 1)',
    'looks-transparent': 'hsla(260, 60%, 60%, 0.35)',
    'looks-light-transparent': 'hsla(260, 60%, 60%, 0.15)',
    'looks-secondary-dark': 'hsla(260, 42%, 51%, 1)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};
